export const stepsEnum = Object.freeze({
  DATOS_CITA: 'DATOS_CITA',
  DATOS_SOLICITANTE: 'DATOS_SOLICITANTE',
  CONFIRMACION_DE_CITA: 'CONFIRMACION_DE_CITA',
});

export default { stepsEnum };
